import { X } from 'lucide-preact';

import { useCustomerLoyalty } from '@/context/LoyaltyContext';
import { useNavigation } from '@/context/NavigationContext';
import { useWidgetConfig } from '@/context/WidgetConfigContext';
import { E_ActiveView, type I_WidgetHeaderProps } from '@/types/WidgetHeader';

export const WidgetHeader = ({ closeWidget, closeButtonRef }: I_WidgetHeaderProps) => {
  const { isRegistered, appName } = useWidgetConfig();
  const { activeView } = useNavigation();
  const { customerLoyalty } = useCustomerLoyalty();

  return (
    <div className='flex flex-row items-center justify-between border-b p-6 pb-4'>
      <div>
        <h2>
          {activeView === E_ActiveView.REDEMPTION
            ? 'Redeem Reward'
            : activeView === E_ActiveView.POST_REGISTRATION
              ? 'Welcome!'
              : activeView === E_ActiveView.FLEXIBLE_POINTS
                ? `Redeem ${customerLoyalty?.programs?.flexiblePoints?.pointsBalanceTitleEn}`
                : isRegistered
                  ? `${appName} Rewards`
                  : `Welcome to ${appName} Rewards`}
        </h2>
        {activeView === E_ActiveView.MAIN && !isRegistered && (
          <h6 className='mt-1 !font-bold'>
            Join our loyalty program and unlock exclusive benefits
          </h6>
        )}
      </div>
      <button
        ref={closeButtonRef}
        onClick={closeWidget}
        aria-label='Close widget'
        className='border-none bg-transparent p-0 text-gray-400 outline-0 transition-colors hover:text-gray-600'
      >
        <X className='h-5 w-5' aria-hidden='true' />
      </button>
    </div>
  );
};
